<app-toolbar>  
  <app-tool-button text="Actualizar" i18n-text (click)="refresh();" color="has-color-blue" icon="fa-sync"></app-tool-button>
  <app-tool-button text="Filtre" i18n-text (click)="onFilterClicked();" color="has-color-orange" icon="fa-filter"></app-tool-button>
  <app-tool-button-permissions [permission]="this.authService.Pages.PropuestasAnulacionZB"></app-tool-button-permissions>
</app-toolbar>
<app-propostes-anulacio-table #table [updatedFilterData]="filter"></app-propostes-anulacio-table>